import { type Language } from '@aikoa/i18n'
import { useCurrentLanguage, useTolgee } from '@aikoa/i18n/react'
import { useCallback } from 'react'
import { LanguageInput } from './LanguageInput'

interface LanguageSelectorProps {
  className?: string
  triggerClassName?: string
  iconClassName?: string
}

export function LanguageSelector({
  className,
  triggerClassName,
  iconClassName,
}: LanguageSelectorProps) {
  const tolgee = useTolgee()
  const currentLanguage = useCurrentLanguage()

  const handleLanguageChange = useCallback(
    async (language: Language) => {
      await tolgee.changeLanguage(language)
    },
    [tolgee]
  )

  return (
    <LanguageInput
      value={currentLanguage}
      onChange={handleLanguageChange}
      className={className}
      triggerClassName={triggerClassName}
      iconClassName={iconClassName}
    />
  )
}
